(ns common.features.plan
  (:require
   [schema.core :as s]
   #?(:clj
      [clojure.edn :as edn])))

(s/defschema ProductPlan
  {(s/optional-key :plan/type)       (s/maybe s/Keyword)
   (s/optional-key :monthly-price)   (s/maybe s/Num)
   (s/optional-key :expires)         (s/maybe s/Num)
   (s/optional-key :perpetual-price) (s/maybe s/Num)
   (s/optional-key :features)        (s/maybe s/Any)})

(defn feature-setting
  [status]
  {:status status})

(defonce default-plans
  {:plan/fundraising
   {:plan/type       :plan/fundraising
    :monthly-price   nil
    :unlimited-users false
    :perpetual-price nil
    :features        {:feature/sell-side-guest         (feature-setting :not-in-use)
                      :feature/checklist               (feature-setting :in-use)
                      :feature/multiple-web-forms      (feature-setting :in-use)
                      :feature/buy-side-guest          (feature-setting :not-in-use)
                      :feature/fundraising             (feature-setting :in-use)
                      :feature/dealflow                (feature-setting :not-in-use)
                      :feature/asset-types-company     (feature-setting :not-in-use)
                      :feature/asset-types-real-estate (feature-setting :not-in-use)
                      :feature/asset-types-other       (feature-setting :not-in-use)
                      :feature/asset-types-fof         (feature-setting :not-in-use)
                      :feature/team-management         (feature-setting :not-in-use)
                      :feature/read-only-access        (feature-setting :not-in-use)
                      :feature/read-only-teams         (feature-setting :not-in-use)
                      :feature/fund-management         (feature-setting :not-in-use)
                      :feature/nylas-integration       (feature-setting :not-in-use)
                      :feature/enrichment-clearbit     (feature-setting :not-in-use)
                      :feature/enrichment-cruchbase    (feature-setting :not-in-use)
                      :feature/authentication-2fa      (feature-setting :not-in-use)
                      :feature/kpi-reporting           (feature-setting :not-in-use)
                      :feature/kyc                     (feature-setting :not-in-use)
                      :feature/tenant-kyc              (feature-setting :not-in-use)
                      :feature/surveys                 (feature-setting :not-in-use)
                      :feature/survey-mass-sending     (feature-setting :not-in-use)
                      :feature/survey-multi-responses  (feature-setting :not-in-use)
                      :feature/survey-skip-responses   (feature-setting :not-in-use)
                      :feature/survey-sms-auth         (feature-setting :not-in-use)
                      :feature/survey-excel-import     (feature-setting :not-in-use)
                      :feature/create-config           (feature-setting :not-in-use)
                      :feature/new-froppo-creation     (feature-setting :not-in-use)
                      :feature/stage-entry-criteria    (feature-setting :not-in-use)
                      :feature/entity-merge            (feature-setting :in-use)
                      :feature/indirect-holdings       (feature-setting :not-in-use)
                      :feature/editable-grid           (feature-setting :not-in-use)
                      :feature/customizable-nev        (feature-setting :not-in-use)
                      :feature/custom-fields           (feature-setting :in-use)
                      :feature/limited-data-sync       (feature-setting :not-in-use)
                      :feature/docusign                (feature-setting :not-in-use)
                      :feature/fee-tracking            (feature-setting :not-in-use)
                      :feature/liabilities             (feature-setting :not-in-use)
                      :feature/saml-sso                (feature-setting :not-in-use)
                      :feature/azure-sso               (feature-setting :not-in-use)
                      :feature/new-sso-2025            (feature-setting :not-in-use)
                      :feature/pdf-memo                (feature-setting :not-in-use)
                      :feature/lp-reporting            (feature-setting :not-in-use)
                      :feature/value-creation-activity (feature-setting :not-in-use)
                      :feature/application-analytics   (feature-setting :in-use)
                      :feature/screening               (feature-setting :not-in-use)
                      :feature/insider-groups          (feature-setting :not-in-use)
                      :feature/new-grid-2023           (feature-setting :not-in-use)
                      :feature/metabase-dashboards     (feature-setting :in-use)
                      :feature/old-dashboards          (feature-setting :not-in-use)
                      :feature/metabase-reporting-db   (feature-setting :not-in-use)
                      :feature/reporting-db            (feature-setting :not-in-use)
                      :feature/pre-investment-checks   (feature-setting :not-in-use)
                      :feature/entity-esign            (feature-setting :not-in-use)
                      :feature/decisions               (feature-setting :not-in-use)
                      :feature/contact-lists           (feature-setting :in-use)
                      :feature/stop-sync-in-background (feature-setting :not-in-use)
                      :feature/performance-testing     (feature-setting :not-in-use)
                      :feature/entity-graph            (feature-setting :not-in-use)
                      :feature/zap-vault               (feature-setting :not-in-use)
                      :feature/counterparty-diligence  (feature-setting :not-in-use)
                      :feature/automated-kyc-renewal   (feature-setting :not-in-use)
                      :feature/contract-kyc            (feature-setting :not-in-use)
                      :feature/outlook-addin           (feature-setting :not-in-use)
                      :feature/mcp-connector           (feature-setting :not-in-use)
                      :feature/ai-deal-parsing         (feature-setting :not-in-use)
                      :feature/ai-enrichment           (feature-setting :not-in-use)
                      :feature/transaction-process     (feature-setting :not-in-use)
                      :feature/transaction-process-dev-mode (feature-setting :not-in-use)}}
   :plan/full-trial
   {:plan/type       :plan/full-trial
    :monthly-price   nil
    :unlimited-users false
    :perpetual-price nil
    :features        {:feature/sell-side-guest         (feature-setting :not-in-use)
                      :feature/checklist               (feature-setting :in-use)
                      :feature/multiple-web-forms      (feature-setting :in-use)
                      :feature/buy-side-guest          (feature-setting :not-in-use)
                      :feature/fundraising             (feature-setting :in-use)
                      :feature/dealflow                (feature-setting :in-use)
                      :feature/sales-pipelines         (feature-setting :not-in-use)
                      :feature/exit-process-management (feature-setting :not-in-use)
                      :feature/asset-types-company     (feature-setting :in-use)
                      :feature/asset-types-real-estate (feature-setting :not-in-use)
                      :feature/asset-types-other       (feature-setting :not-in-use)
                      :feature/asset-types-fof         (feature-setting :not-in-use)
                      :feature/team-management         (feature-setting :not-in-use)
                      :feature/read-only-access        (feature-setting :not-in-use)
                      :feature/read-only-teams         (feature-setting :not-in-use)
                      :feature/fund-management         (feature-setting :not-in-use)
                      :feature/nylas-integration       (feature-setting :in-use)
                      :feature/enrichment-clearbit     (feature-setting :not-in-use)
                      :feature/enrichment-cruchbase    (feature-setting :in-use)
                      :feature/authentication-2fa      (feature-setting :not-in-use)
                      :feature/kpi-reporting           (feature-setting :not-in-use)
                      :feature/kyc                     (feature-setting :not-in-use)
                      :feature/tenant-kyc              (feature-setting :not-in-use)
                      :feature/surveys                 (feature-setting :not-in-use)
                      :feature/survey-mass-sending     (feature-setting :not-in-use)
                      :feature/survey-multi-responses  (feature-setting :not-in-use)
                      :feature/survey-skip-responses   (feature-setting :not-in-use)
                      :feature/survey-sms-auth         (feature-setting :not-in-use)
                      :feature/survey-excel-import     (feature-setting :not-in-use)
                      :feature/create-config           (feature-setting :not-in-use)
                      :feature/new-froppo-creation     (feature-setting :not-in-use)
                      :feature/stage-entry-criteria    (feature-setting :not-in-use)
                      :feature/entity-merge            (feature-setting :in-use)
                      :feature/indirect-holdings       (feature-setting :not-in-use)
                      :feature/editable-grid           (feature-setting :not-in-use)
                      :feature/customizable-nev        (feature-setting :not-in-use)
                      :feature/custom-fields           (feature-setting :in-use)
                      :feature/limited-data-sync       (feature-setting :not-in-use)
                      :feature/docusign                (feature-setting :not-in-use)
                      :feature/risk-module             (feature-setting :not-in-use)
                      :feature/pdf-memo                (feature-setting :in-use)
                      :feature/fee-tracking            (feature-setting :not-in-use)
                      :feature/liabilities             (feature-setting :not-in-use)
                      :feature/saml-sso                (feature-setting :not-in-use)
                      :feature/azure-sso               (feature-setting :not-in-use)
                      :feature/new-sso-2025            (feature-setting :not-in-use)
                      :feature/lp-reporting            (feature-setting :not-in-use)
                      :feature/value-creation-activity (feature-setting :not-in-use)
                      :feature/application-analytics   (feature-setting :in-use)
                      :feature/tasks-kanban            (feature-setting :not-in-use)
                      :feature/screening               (feature-setting :not-in-use)
                      :feature/insider-groups          (feature-setting :not-in-use)
                      :feature/new-grid-2023           (feature-setting :not-in-use)
                      :feature/entity-esign            (feature-setting :not-in-use)
                      :feature/pre-investment-checks   (feature-setting :not-in-use)
                      :feature/metabase-dashboards     (feature-setting :in-use)
                      :feature/old-dashboards          (feature-setting :not-in-use)
                      :feature/metabase-reporting-db   (feature-setting :not-in-use)
                      :feature/reporting-db            (feature-setting :not-in-use)
                      :feature/decisions               (feature-setting :not-in-use)
                      :feature/contact-lists           (feature-setting :in-use)
                      :feature/stop-sync-in-background (feature-setting :not-in-use)
                      :feature/performance-testing     (feature-setting :not-in-use)
                      :feature/entity-graph            (feature-setting :not-in-use)
                      :feature/zap-vault               (feature-setting :not-in-use)
                      :feature/counterparty-diligence  (feature-setting :not-in-use)
                      :feature/automated-kyc-renewal   (feature-setting :not-in-use)
                      :feature/contract-kyc            (feature-setting :not-in-use)
                      :feature/outlook-addin           (feature-setting :not-in-use)
                      :feature/mcp-connector           (feature-setting :not-in-use)
                      :feature/ai-deal-parsing         (feature-setting :not-in-use)
                      :feature/ai-enrichment           (feature-setting :not-in-use)
                      :feature/transaction-process     (feature-setting :not-in-use)
                      :feature/transaction-process-dev-mode (feature-setting :not-in-use)}}
   :plan/limited-trial
   {:plan/type       :plan/limited-trial
    :monthly-price   12
    :unlimited-users false
    :perpetual-price nil
    :features        {:feature/sell-side-guest         (feature-setting :not-in-use)
                      :feature/checklist               (feature-setting :in-use)
                      :feature/multiple-web-forms      (feature-setting :in-use)
                      :feature/buy-side-guest          (feature-setting :not-in-use)
                      :feature/fundraising             (feature-setting :in-use)
                      :feature/dealflow                (feature-setting :in-use)
                      :feature/sales-pipelines         (feature-setting :not-in-use)
                      :feature/exit-process-management (feature-setting :not-in-use)
                      :feature/asset-types-company     (feature-setting :in-use)
                      :feature/asset-types-real-estate (feature-setting :not-in-use)
                      :feature/asset-types-other       (feature-setting :not-in-use)
                      :feature/asset-types-fof         (feature-setting :not-in-use)
                      :feature/team-management         (feature-setting :not-in-use)
                      :feature/read-only-access        (feature-setting :not-in-use)
                      :feature/read-only-teams         (feature-setting :not-in-use)
                      :feature/fund-management         (feature-setting :not-in-use)
                      :feature/nylas-integration       (feature-setting :not-in-use)
                      :feature/enrichment-clearbit     (feature-setting :not-in-use)
                      :feature/enrichment-cruchbase    (feature-setting :in-use)
                      :feature/authentication-2fa      (feature-setting :not-in-use)
                      :feature/kpi-reporting           (feature-setting :not-in-use)
                      :feature/kyc                     (feature-setting :not-in-use)
                      :feature/tenant-kyc              (feature-setting :not-in-use)
                      :feature/surveys                 (feature-setting :not-in-use)
                      :feature/survey-mass-sending     (feature-setting :not-in-use)
                      :feature/survey-multi-responses  (feature-setting :not-in-use)
                      :feature/survey-skip-responses   (feature-setting :not-in-use)
                      :feature/survey-sms-auth         (feature-setting :not-in-use)
                      :feature/survey-excel-import     (feature-setting :not-in-use)
                      :feature/create-config           (feature-setting :not-in-use)
                      :feature/new-froppo-creation     (feature-setting :not-in-use)
                      :feature/stage-entry-criteria    (feature-setting :not-in-use)
                      :feature/entity-merge            (feature-setting :in-use)
                      :feature/indirect-holdings       (feature-setting :not-in-use)
                      :feature/editable-grid           (feature-setting :not-in-use)
                      :feature/customizable-nev        (feature-setting :not-in-use)
                      :feature/custom-fields           (feature-setting :in-use)
                      :feature/limited-data-sync       (feature-setting :not-in-use)
                      :feature/docusign                (feature-setting :not-in-use)
                      :feature/risk-module             (feature-setting :not-in-use)
                      :feature/pdf-memo                (feature-setting :in-use)
                      :feature/fee-tracking            (feature-setting :not-in-use)
                      :feature/liabilities             (feature-setting :not-in-use)
                      :feature/saml-sso                (feature-setting :not-in-use)
                      :feature/azure-sso               (feature-setting :not-in-use)
                      :feature/new-sso-2025            (feature-setting :not-in-use)
                      :feature/lp-reporting            (feature-setting :not-in-use)
                      :feature/value-creation-activity (feature-setting :not-in-use)
                      :feature/application-analytics   (feature-setting :in-use)
                      :feature/tasks-kanban            (feature-setting :not-in-use)
                      :feature/screening               (feature-setting :not-in-use)
                      :feature/insider-groups          (feature-setting :not-in-use)
                      :feature/new-grid-2023           (feature-setting :not-in-use)
                      :feature/entity-esign            (feature-setting :not-in-use)
                      :feature/pre-investment-checks   (feature-setting :not-in-use)
                      :feature/metabase-dashboards     (feature-setting :in-use)
                      :feature/old-dashboards          (feature-setting :not-in-use)
                      :feature/metabase-reporting-db   (feature-setting :not-in-use)
                      :feature/reporting-db            (feature-setting :not-in-use)
                      :feature/decisions               (feature-setting :not-in-use)
                      :feature/contact-lists           (feature-setting :in-use)
                      :feature/stop-sync-in-background (feature-setting :not-in-use)
                      :feature/performance-testing     (feature-setting :not-in-use)
                      :feature/entity-graph            (feature-setting :not-in-use)
                      :feature/zap-vault               (feature-setting :not-in-use)
                      :feature/counterparty-diligence  (feature-setting :not-in-use)
                      :feature/automated-kyc-renewal   (feature-setting :not-in-use)
                      :feature/contract-kyc            (feature-setting :not-in-use)
                      :feature/outlook-addin           (feature-setting :not-in-use)
                      :feature/ai-deal-parsing         (feature-setting :not-in-use)
                      :feature/ai-enrichment           (feature-setting :not-in-use)
                      :feature/mcp-connector           (feature-setting :not-in-use)
                      :feature/transaction-process     (feature-setting :not-in-use)
                      :feature/transaction-process-dev-mode (feature-setting :not-in-use)}}
   :plan/standard
   {:plan/type       :plan/standard
    :monthly-price   35
    :unlimited-users false
    :perpetual-price nil
    :features        {:feature/sell-side-guest         (feature-setting :not-in-use)
                      :feature/checklist               (feature-setting :in-use)
                      :feature/multiple-web-forms      (feature-setting :in-use)
                      :feature/buy-side-guest          (feature-setting :not-in-use)
                      :feature/fundraising             (feature-setting :in-use)
                      :feature/dealflow                (feature-setting :in-use)
                      :feature/sales-pipelines         (feature-setting :not-in-use)
                      :feature/exit-process-management (feature-setting :not-in-use)
                      :feature/asset-types-company     (feature-setting :in-use)
                      :feature/asset-types-real-estate (feature-setting :not-in-use)
                      :feature/asset-types-other       (feature-setting :not-in-use)
                      :feature/asset-types-fof         (feature-setting :not-in-use)
                      :feature/team-management         (feature-setting :not-in-use)
                      :feature/read-only-access        (feature-setting :not-in-use)
                      :feature/read-only-teams         (feature-setting :not-in-use)
                      :feature/fund-management         (feature-setting :not-in-use)
                      :feature/nylas-integration       (feature-setting :not-in-use)
                      :feature/enrichment-clearbit     (feature-setting :not-in-use)
                      :feature/enrichment-cruchbase    (feature-setting :in-use)
                      :feature/authentication-2fa      (feature-setting :not-in-use)
                      :feature/kpi-reporting           (feature-setting :not-in-use)
                      :feature/kyc                     (feature-setting :not-in-use)
                      :feature/tenant-kyc              (feature-setting :not-in-use)
                      :feature/surveys                 (feature-setting :not-in-use)
                      :feature/survey-mass-sending     (feature-setting :not-in-use)
                      :feature/survey-multi-responses  (feature-setting :not-in-use)
                      :feature/survey-skip-responses   (feature-setting :not-in-use)
                      :feature/survey-sms-auth         (feature-setting :not-in-use)
                      :feature/survey-excel-import     (feature-setting :not-in-use)
                      :feature/create-config           (feature-setting :not-in-use)
                      :feature/new-froppo-creation     (feature-setting :not-in-use)
                      :feature/stage-entry-criteria    (feature-setting :not-in-use)
                      :feature/entity-merge            (feature-setting :in-use)
                      :feature/indirect-holdings       (feature-setting :not-in-use)
                      :feature/editable-grid           (feature-setting :not-in-use)
                      :feature/customizable-nev        (feature-setting :not-in-use)
                      :feature/custom-fields           (feature-setting :in-use)
                      :feature/limited-data-sync       (feature-setting :not-in-use)
                      :feature/docusign                (feature-setting :not-in-use)
                      :feature/risk-module             (feature-setting :not-in-use)
                      :feature/pdf-memo                (feature-setting :in-use)
                      :feature/fee-tracking            (feature-setting :not-in-use)
                      :feature/liabilities             (feature-setting :not-in-use)
                      :feature/saml-sso                (feature-setting :not-in-use)
                      :feature/azure-sso               (feature-setting :not-in-use)
                      :feature/new-sso-2025            (feature-setting :not-in-use)
                      :feature/lp-reporting            (feature-setting :not-in-use)
                      :feature/value-creation-activity (feature-setting :not-in-use)
                      :feature/application-analytics   (feature-setting :in-use)
                      :feature/tasks-kanban            (feature-setting :not-in-use)
                      :feature/screening               (feature-setting :not-in-use)
                      :feature/insider-groups          (feature-setting :not-in-use)
                      :feature/new-grid-2023           (feature-setting :not-in-use)
                      :feature/entity-esign            (feature-setting :not-in-use)
                      :feature/pre-investment-checks   (feature-setting :not-in-use)
                      :feature/metabase-dashboards     (feature-setting :in-use)
                      :feature/old-dashboards          (feature-setting :not-in-use)
                      :feature/metabase-reporting-db   (feature-setting :not-in-use)
                      :feature/reporting-db            (feature-setting :not-in-use)
                      :feature/decisions               (feature-setting :not-in-use)
                      :feature/contact-lists           (feature-setting :in-use)
                      :feature/stop-sync-in-background (feature-setting :not-in-use)
                      :feature/performance-testing     (feature-setting :not-in-use)
                      :feature/entity-graph            (feature-setting :not-in-use)
                      :feature/zap-vault               (feature-setting :not-in-use)
                      :feature/counterparty-diligence  (feature-setting :not-in-use)
                      :feature/automated-kyc-renewal   (feature-setting :not-in-use)
                      :feature/contract-kyc            (feature-setting :not-in-use)
                      :feature/outlook-addin           (feature-setting :not-in-use)
                      :feature/ai-deal-parsing         (feature-setting :not-in-use)
                      :feature/ai-enrichment           (feature-setting :not-in-use)
                      :feature/mcp-connector           (feature-setting :not-in-use)
                      :feature/transaction-process     (feature-setting :not-in-use)
                      :feature/transaction-process-dev-mode (feature-setting :not-in-use)}}
   :plan/pro
   {:plan/type       :plan/pro
    :monthly-price   95
    :unlimited-users false
    :perpetual-price nil
    :features        {:feature/sell-side-guest         (feature-setting :not-in-use)
                      :feature/checklist               (feature-setting :in-use)
                      :feature/multiple-web-forms      (feature-setting :in-use)
                      :feature/buy-side-guest          (feature-setting :not-in-use)
                      :feature/fundraising             (feature-setting :in-use)
                      :feature/dealflow                (feature-setting :in-use)
                      :feature/sales-pipelines         (feature-setting :not-in-use)
                      :feature/exit-process-management (feature-setting :not-in-use)
                      :feature/asset-types-company     (feature-setting :in-use)
                      :feature/asset-types-real-estate (feature-setting :not-in-use)
                      :feature/asset-types-other       (feature-setting :not-in-use)
                      :feature/asset-types-fof         (feature-setting :not-in-use)
                      :feature/team-management         (feature-setting :not-in-use)
                      :feature/read-only-access        (feature-setting :not-in-use)
                      :feature/read-only-teams         (feature-setting :not-in-use)
                      :feature/fund-management         (feature-setting :not-in-use)
                      :feature/nylas-integration       (feature-setting :not-in-use)
                      :feature/enrichment-clearbit     (feature-setting :not-in-use)
                      :feature/enrichment-cruchbase    (feature-setting :in-use)
                      :feature/authentication-2fa      (feature-setting :not-in-use)
                      :feature/kpi-reporting           (feature-setting :not-in-use)
                      :feature/kyc                     (feature-setting :not-in-use)
                      :feature/tenant-kyc              (feature-setting :not-in-use)
                      :feature/surveys                 (feature-setting :not-in-use)
                      :feature/survey-mass-sending     (feature-setting :not-in-use)
                      :feature/survey-multi-responses  (feature-setting :not-in-use)
                      :feature/survey-skip-responses   (feature-setting :not-in-use)
                      :feature/survey-sms-auth         (feature-setting :not-in-use)
                      :feature/survey-excel-import     (feature-setting :not-in-use)
                      :feature/create-config           (feature-setting :not-in-use)
                      :feature/new-froppo-creation     (feature-setting :not-in-use)
                      :feature/stage-entry-criteria    (feature-setting :not-in-use)
                      :feature/entity-merge            (feature-setting :in-use)
                      :feature/indirect-holdings       (feature-setting :not-in-use)
                      :feature/editable-grid           (feature-setting :not-in-use)
                      :feature/customizable-nev        (feature-setting :not-in-use)
                      :feature/custom-fields           (feature-setting :in-use)
                      :feature/limited-data-sync       (feature-setting :not-in-use)
                      :feature/docusign                (feature-setting :not-in-use)
                      :feature/risk-module             (feature-setting :not-in-use)
                      :feature/pdf-memo                (feature-setting :in-use)
                      :feature/fee-tracking            (feature-setting :not-in-use)
                      :feature/liabilities             (feature-setting :not-in-use)
                      :feature/saml-sso                (feature-setting :not-in-use)
                      :feature/azure-sso               (feature-setting :not-in-use)
                      :feature/new-sso-2025            (feature-setting :not-in-use)
                      :feature/lp-reporting            (feature-setting :not-in-use)
                      :feature/value-creation-activity (feature-setting :not-in-use)
                      :feature/application-analytics   (feature-setting :in-use)
                      :feature/tasks-kanban            (feature-setting :not-in-use)
                      :feature/screening               (feature-setting :not-in-use)
                      :feature/insider-groups          (feature-setting :not-in-use)
                      :feature/new-grid-2023           (feature-setting :not-in-use)
                      :feature/entity-esign            (feature-setting :not-in-use)
                      :feature/pre-investment-checks   (feature-setting :not-in-use)
                      :feature/metabase-dashboards     (feature-setting :in-use)
                      :feature/old-dashboards          (feature-setting :not-in-use)
                      :feature/metabase-reporting-db   (feature-setting :not-in-use)
                      :feature/reporting-db            (feature-setting :not-in-use)
                      :feature/decisions               (feature-setting :not-in-use)
                      :feature/contact-lists           (feature-setting :in-use)
                      :feature/stop-sync-in-background (feature-setting :not-in-use)
                      :feature/performance-testing     (feature-setting :not-in-use)
                      :feature/entity-graph            (feature-setting :not-in-use)
                      :feature/zap-vault               (feature-setting :not-in-use)
                      :feature/counterparty-diligence  (feature-setting :not-in-use)
                      :feature/automated-kyc-renewal   (feature-setting :not-in-use)
                      :feature/contract-kyc            (feature-setting :not-in-use)
                      :feature/outlook-addin           (feature-setting :not-in-use)
                      :feature/ai-deal-parsing         (feature-setting :not-in-use)
                      :feature/ai-enrichment           (feature-setting :not-in-use)
                      :feature/mcp-connector           (feature-setting :not-in-use)
                      :feature/transaction-process     (feature-setting :not-in-use)
                      :feature/transaction-process-dev-mode (feature-setting :not-in-use)}}
   :plan/enterprise
   {:plan/type       :plan/enterprise
    :monthly-price   295
    :unlimited-users false
    :perpetual-price nil
    :features        {:feature/sell-side-guest                 (feature-setting :not-in-use)
                      :feature/checklist                       (feature-setting :in-use)
                      :feature/multiple-web-forms              (feature-setting :in-use)
                      :feature/buy-side-guest                  (feature-setting :not-in-use)
                      :feature/fundraising                     (feature-setting :in-use)
                      :feature/dealflow                        (feature-setting :in-use)
                      :feature/sales-pipelines                 (feature-setting :not-in-use)
                      :feature/exit-process-management         (feature-setting :not-in-use)
                      :feature/asset-types-company             (feature-setting :in-use)
                      :feature/asset-types-real-estate         (feature-setting :not-in-use)
                      :feature/asset-types-other               (feature-setting :not-in-use)
                      :feature/asset-types-fof                 (feature-setting :not-in-use)
                      :feature/team-management                 (feature-setting :not-in-use)
                      :feature/read-only-access                (feature-setting :not-in-use)
                      :feature/read-only-teams                 (feature-setting :not-in-use)
                      :feature/fund-management                 (feature-setting :not-in-use)
                      :feature/nylas-integration               (feature-setting :not-in-use)
                      :feature/enrichment-clearbit             (feature-setting :not-in-use)
                      :feature/enrichment-cruchbase            (feature-setting :in-use)
                      :feature/authentication-2fa              (feature-setting :not-in-use)
                      :feature/kpi-reporting                   (feature-setting :not-in-use)
                      :feature/kyc                             (feature-setting :not-in-use)
                      :feature/tenant-kyc                      (feature-setting :not-in-use)
                      :feature/surveys                         (feature-setting :not-in-use)
                      :feature/survey-mass-sending             (feature-setting :not-in-use)
                      :feature/survey-multi-responses          (feature-setting :not-in-use)
                      :feature/survey-skip-responses           (feature-setting :not-in-use)
                      :feature/survey-sms-auth                 (feature-setting :not-in-use)
                      :feature/survey-excel-import             (feature-setting :not-in-use)
                      :feature/create-config                   (feature-setting :not-in-use)
                      :feature/new-froppo-creation             (feature-setting :not-in-use)
                      :feature/stage-entry-criteria            (feature-setting :not-in-use)
                      :feature/entity-merge                    (feature-setting :in-use)
                      :feature/indirect-holdings               (feature-setting :not-in-use)
                      :feature/editable-grid                   (feature-setting :not-in-use)
                      :feature/customizable-nev                (feature-setting :not-in-use)
                      :feature/custom-fields                   (feature-setting :in-use)
                      :feature/limited-data-sync               (feature-setting :not-in-use)
                      :feature/docusign                        (feature-setting :not-in-use)
                      :feature/risk-module                     (feature-setting :not-in-use)
                      :feature/pdf-memo                        (feature-setting :in-use)
                      :feature/fee-tracking                    (feature-setting :not-in-use)
                      :feature/liabilities                     (feature-setting :not-in-use)
                      :feature/saml-sso                        (feature-setting :not-in-use)
                      :feature/azure-sso                       (feature-setting :not-in-use)
                      :feature/new-sso-2025                    (feature-setting :not-in-use)
                      :feature/lp-reporting                    (feature-setting :not-in-use)
                      :feature/value-creation-activity         (feature-setting :not-in-use)
                      :feature/application-analytics           (feature-setting :in-use)
                      :feature/tasks-kanban                    (feature-setting :not-in-use)
                      :feature/screening                       (feature-setting :not-in-use)
                      :feature/insider-groups                  (feature-setting :not-in-use)
                      :feature/new-grid-2023                   (feature-setting :not-in-use)
                      :feature/entity-esign                    (feature-setting :not-in-use)
                      :feature/pre-investment-checks           (feature-setting :not-in-use)
                      :feature/metabase-dashboards             (feature-setting :in-use)
                      :feature/old-dashboards                  (feature-setting :not-in-use)
                      :feature/metabase-reporting-db           (feature-setting :not-in-use)
                      :feature/reporting-db                    (feature-setting :not-in-use)
                      :feature/decisions                       (feature-setting :not-in-use)
                      :feature/contact-lists                   (feature-setting :in-use)
                      :feature/stop-sync-in-background         (feature-setting :not-in-use)
                      :feature/performance-testing             (feature-setting :not-in-use)
                      :feature/new-company-viewer-preview-2024 (feature-setting :not-in-use)
                      :feature/entity-graph                    (feature-setting :not-in-use)
                      :feature/zap-vault                       (feature-setting :not-in-use)
                      :feature/counterparty-diligence          (feature-setting :not-in-use)
                      :feature/automated-kyc-renewal           (feature-setting :not-in-use)
                      :feature/contract-kyc                    (feature-setting :not-in-use)
                      :feature/outlook-addin                   (feature-setting :not-in-use)
                      :feature/mcp-connector                   (feature-setting :not-in-use)
                      :feature/transaction-process             (feature-setting :not-in-use)
                      :feature/transaction-process-dev-mode    (feature-setting :not-in-use)}}})

(def feature-kws
  (->> default-plans
       (map val)
       (mapcat :features)
       (map key)
       (distinct)))

(defn has-module-access-to-feature
  [feature accessible-modules]
  (cond (some #{feature} [:feature/asset-types-other :feature/asset-types-fof :feature/asset-types-real-estate :feature/asset-types-company])
        (some #{:module/dealflow} accessible-modules)
        :else
        true))

(defn resolve-plan
  [tenant]
  (let [plan (:tenant/product-plan tenant)]
    #?(:cljs plan
       :clj  (edn/read-string plan))))

(defn available
  ([feature tenant]
   (available feature tenant nil))
  ([feature tenant role]
   (available feature tenant role nil))
  ([feature tenant role plan]
   (if (= role :role/sys-admin)
     true
     (let [plan (or (when (not (keyword? plan))
                      plan)
                    (resolve-plan tenant))
           current-plan (:plan/type plan)
           ;;if not found in tenant product-plan, take feature status
           ;; from default-plans
           status (or (->> plan
                           :features
                           feature
                           :status)
                      (some-> default-plans
                              (get current-plan)
                              :features
                              feature
                              :status))
           in-use (cond
                    (not= :in-use status) false
                    :else true)]
       in-use))))
